import { gql } from "@apollo/client";

/**
 * The header's event list is already scoped to what this user may see and to
 * the header's organization, so the page asks for exactly those ids rather than
 * re-deriving the scope.
 */
export const REFUND_MANAGER_EVENTS = gql`
  query RefundManagerEvents($ids: [Int!]!) {
    events(where: { id: { _in: $ids } }) {
      id
      name
      slug
      end_date
      timezone
      timezone_diff
      is_active
      cashless_configurations
    }
    cashless_refund_requests(where: { event_id: { _in: $ids } }) {
      event_id
      status
      amount
      gross_amount
      fee_amount
      needs_manual_fix
    }
  }
`;

/**
 * _append is a jsonb || merge at the top level: it replaces the cash_refund key
 * and leaves every other key in cashless_configurations exactly as stored. That
 * is the whole reason this is not a _set — a _set of the column would wipe
 * registration_header, remaining_due_buttons and the rest.
 *
 * The caller still merges INSIDE cash_refund (keeping payout_methods and any
 * key this page does not edit) before sending it.
 */
export const SAVE_CASH_REFUND_CONFIG = gql`
  mutation SaveCashRefundConfig($id: Int!, $config: jsonb!, $updatedBy: Int) {
    update_events_by_pk(
      pk_columns: { id: $id }
      _append: { cashless_configurations: $config }
      _set: { last_updated_by: $updatedBy }
    ) {
      id
      cashless_configurations
    }
  }
`;

/**
 * For an event whose cashless_configurations is NULL. _append compiles to
 * Postgres `column || value`, and NULL || anything is NULL — so appending to a
 * null column reports success and stores nothing. With no existing keys there
 * is nothing to preserve, so a _set of just cash_refund is safe here.
 */
export const SET_CASH_REFUND_CONFIG = gql`
  mutation SetCashRefundConfig($id: Int!, $config: jsonb!, $updatedBy: Int) {
    update_events_by_pk(
      pk_columns: { id: $id }
      _set: { cashless_configurations: $config, last_updated_by: $updatedBy }
    ) {
      id
      cashless_configurations
    }
  }
`;
